import React, { useEffect, useState } from "react";
import { Button, Row, Col, Card, NavLink, Badge } from "react-bootstrap";
import { LAYOUT } from "constants.js";
import CsLineIcons from "cs-line-icons/CsLineIcons";
import Clamp from "components/clamp";
import { format } from "date-fns";
import _ from "lodash";
import PropTypes from "prop-types";

const Trainings = ({ user, training, tabHandler, ...props }) => {
  return (
    <>
      <Row className={props.index === 0 ? "g-0 mt-0" : "g-0 mt-2"}>
        <Col xs="auto" className="me-3">
          <div
            className="bg-foreground sw-7 sh-7 rounded-xl shadow d-flex flex-shrink-0 justify-content-center align-items-center"
            style={{ marginTop: "-6px" }}
          >
            <div className="bg-gradient-light sw-5 sh-5 rounded-xl">
              <div className="text-white d-flex justify-content-center align-items-center h-100 text-small text-center lh-1">
                {training.icon && training.icon !== "" ? (
                  <img
                    className="sw-5 sh-5 rounded-xl"
                    src={training.icon}
                    alt="Training Image"
                    style={{ width: "100%", height: "100%" }}
                  />
                ) : (
                  <i
                    className={`text-forground bi-journal-text`}
                    style={{ fontSize: "1.4rem" }}
                  />
                )}
              </div>
            </div>
          </div>
        </Col>
        <Col>
          <NavLink className="m-0 p-0" onClick={() => tabHandler("Trainings")}>
            {training.title}
          </NavLink>
          <p className="text-muted">
            {training.trainingType} | {training.duration} Hrs
          </p>
        </Col>
      </Row>
    </>
  );
};

export default Trainings;
Trainings.propTypes = {
  user: PropTypes.object.isRequired,
  training: PropTypes.object.isRequired,
};
